export const BillingEvent = {
  ON_CHANGE_PLAN_SUCCESS: 'BillingEvent:ON_CHANGE_PLAN_SUCCESS',
  ON_CHECKOUT_SUCCESS: 'BillingEvent:ON_CHECKOUT_SUCCESS',
  ON_UPDATE_PAYMENT_SUCCESS: 'BillingEvent:ON_UPDATE_PAYMENT_SUCCESS',
  ON_REMOVE_PAYMENT_SUCCESS: 'BillingEvent:ON_REMOVE_PAYMENT_SUCCESS',
  ON_STRIPE_CONFIRM: 'BillingEvent:ON_STRIPE_CONFIRM',
  ON_PAYWALL_CLOSED: 'BillingEvent:ON_PAYWALL_CLOSED'
};
